import { DocumentSnapshot, DocumentReference } from "firebase/firestore";
import SecureatSnapshot from "../SecureatSnapshot";
import Attachment from "../Filesystem/Attachment";
import Quiz from "@/model/Communication/Quiz";
import * as DateUtils from "@/utils/DateUtils";
import CommunicationTarget from "../Communication/SecureatTarget";
import TrainingSection from "./TrainingSection";
import { TrainingType } from "./TrainingType";
import SecureatTarget from "../Communication/SecureatTarget";

export default class Training extends SecureatSnapshot {
  active: boolean;
  user: DocumentReference;
  name: string;
  target: SecureatTarget;
  type: TrainingType;
  sections: TrainingSection[];
  source: DocumentReference;
  lang: string;
  required: boolean;
  category: DocumentReference | null;

  constructor(
    ref: DocumentReference,
    active: boolean,
    user: DocumentReference,
    name: string,
    target: SecureatTarget,
    type: TrainingType,
    sections: TrainingSection[],
    source: DocumentReference,
    lang: string,
    required: boolean,
    category: DocumentReference | null,
  ) {
    super(ref);
    this.active = active;
    this.user = user;
    this.name = name;
    this.target = target;
    this.type = type;
    this.sections = sections;
    this.source = source;
    this.lang = lang;
    this.required = required;
    this.category = category;
  }

  public static fromFirestore(snapshot: DocumentSnapshot): Training {
    const data = snapshot.data()!;

    let result = new Training(
      snapshot.ref,
      data.active,
      data.user,
      data.name,
      SecureatTarget.fromFirestore(data.target),
      data.type,
      data.sections != null && data.sections != undefined
        ? data.sections.map((x) => TrainingSection.fromFirestore(x))
        : [],
      data.source ? data.source : null,
      data.lang,
      data.required == undefined ? false : data.required,
      data.category == undefined ? null : data.category,
    );
    return result;
  }

  public toFirestore() {
    return {
      active: this.active,
      user: this.user,
      name: this.name,
      target: this.target.toFirestore(),
      type: this.type,
      sections: this.sections.map((x) => x.toFirestore()),
      source: this.source,
      lang: this.lang,
      required: this.required,
      category: this.category,
    };
  }
  public clone() {
    return new Training(
      this.ref,
      this.active,
      this.user,
      this.name,
      this.target.clone(),
      this.type,
      this.sections.map((x) => x.clone()),
      this.source,
      this.lang,
      this.required,
      this.category,
    );
  }
}
